import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { withErrorBoundary } from 'react-error-boundary';
import LogoLoader from '../../components/Display/LogoLoader/LogoLoader';

const ErrorFallback = (
  <div>
    <p className="p-2">An unexpected error occurred. Please refresh your browser. If the issue persists, contact the Support team.</p>
  </div>
);

export default function ComponentLibraryLoader({ loadFn, loadingApp, source, component = 'default', datadogRum = null }) {
  return loadable(loadFn, {
    fallback: <LogoLoader height={100} styleClass={'flex flex-col'}/>,
    resolveComponent(components) {
      return withErrorBoundary(components[component], {
        fallback: ErrorFallback,
        onError(error, info) {
          if (datadogRum) {
            datadogRum.addError(`[${loadingApp}] [Source: '${source}'] - ${error}`, info);
          }
        },
      });
    },
  });
}

ComponentLibraryLoader.propTypes = {
  component: PropTypes.string,
  datadogRum: PropTypes.object,
  loadFn: PropTypes.func.isRequired,
  loadingApp: PropTypes.oneOf(['app-client', 'uniteus-emr']).isRequired,
  source: PropTypes.string.isRequired,
};
